// extracted by mini-css-extract-plugin
export default {"StepBreadcrumbs":"StepBreadcrumbs_StepBreadcrumbs__BxiZh","StepsBlock":"StepBreadcrumbs_StepsBlock__T6QI2","Step":"StepBreadcrumbs_Step__L3-mF"};